/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type CommissionStatus = typeof CommissionStatus[keyof typeof CommissionStatus];


export const CommissionStatus = {
  unpaid: 'unpaid',
  settled: 'settled',
} as const;
